export const CUSTOMER_IO_PAGEVIEW_EVENT = "pageview";
export const CUSTOMER_IO_CTA_CLICK_EVENT = "cta_click";
